"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Combine = ({
  classes,
  children
}) => _react.default.createElement("div", {
  className: classes.root
}, children);

var _default = (0, _reactJss.default)(theme => ({
  root: {
    display: 'flex',
    '& > *:not(:last-child)': {
      flexGrow: 1,
      '&, & .form-input': {
        borderTopRightRadius: '0 !important',
        borderBottomRightRadius: '0 !important'
      }
    },
    '& > * + *': {
      borderTopLeftRadius: '0 !important',
      borderBottomLeftRadius: '0 !important'
    },
    '& > *': {
      margin: '0 !important'
    }
  }
}))(Combine);

exports.default = _default;